var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('title',[_vm._v("DegreeSee")]),(_vm.signedIn === true)?_c('div',{staticClass:"dash-collection-home",attrs:{"id":"content"}},[_c('dash-collection')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }